import { frontendURL } from 'dashboard/helper/URLHelper';
import PipelinesIndex from './pages/Index.vue';
import DealDetailView from './pages/DealDetailView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/pipelines'),
    name: 'pipelines_home',
    component: PipelinesIndex,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/pipelines/:pipelineId'),
    name: 'pipelines_view',
    component: PipelinesIndex,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/pipelines/:pipelineId/deals/:dealId'),
    name: 'pipelines_deal',
    component: DealDetailView,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
